(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-showcase"] && !Shopify.designMode) return;
  try {
    
// JavaScript代码放在assets/feature-showcase.js中

  } catch(e) { console.error(e); }
})();
})();
